import { interfaces } from 'inversify';
import { DI_TYPES } from '../di-types';
import { ClientEventDB } from '../v2/client-event-db/client-event-db';

export type ClientEventDBProvider = () => Promise<ClientEventDB>;

export const ClientEventDBProviderCreator: interfaces.ProviderCreator<ClientEventDB> = context => () =>
  new Promise<ClientEventDB>((resolve, reject) => {
    const clientEventDb = context.container.get<ClientEventDB>(DI_TYPES.ClientEventDB);

    resolve(clientEventDb);
  });
